import type { JSX } from 'react'

import { ui } from '~/core/skin'
import { AppTitle } from '~/shared/ui/components/AppTitle'
import { Skeleton } from '~/shared/ui/components/Skeleton'

export function Title(): JSX.Element {
  return <AppTitle>Logout</AppTitle>
}

LogoutPage.displayName = 'LogoutPage'
export function LogoutPage(): JSX.Element {
  return (
    <ui.PageWrapper>
      <Skeleton pageType='main' isLoading={true}>
        <></>
      </Skeleton>
    </ui.PageWrapper>
  )
}
